<template>
    <div :class="{ 'top-border': hasTopBorder }" class="stat">
        <div class="title">{{ stat.title }}</div>
        <div class="bar-container">
            <div class="background"></div>
            <div
                class="values"
                ref="bar"
                :style="{ width: width, left: start }"
            ></div>
        </div>
        <div class="scale" v-show="stat.scale">
            <div
                class="scale-item"
                v-for="(item, sindex) in stat.scale"
                :key="sindex"
                :style="{ left: getScaleItemPos(sindex) }"
            >
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
import { gsap, Power4 } from 'gsap';

export default {
    props: ['stat', 'show', 'delay'],
    computed: {
        hasTopBorder() {
            return this.stat.title == 'HP';
        },
        actualValue() {
            return this.stat.start_value
                ? this.stat.value - this.stat.start_value
                : this.stat.value;
        },
        widthNum() {
            return (this.actualValue / this.stat.max_value) * 100;
        },
        width() {
            return `${this.widthNum}%`;
        },
        startNum() {
            let start = this.stat.start_value ? this.stat.start_value : 0;
            return (start / this.stat.max_value) * 100;
        },
        start() {
            return `${this.startNum}%`;
        },
    },

    methods: {
        getScaleItemPos(index) {
            return `${(index / (this.stat.scale.length - 1)) * 100}%`;
        },
    },

    watch: {
        show(show) {
            if (show) {
                gsap.fromTo(
                    this.$refs.bar,
                    { width: 0, backgroundColor: '#FFFFFF' },
                    {
                        delay: this.delay,
                        width: this.width,
                        backgroundColor: '#62bb46',
                        ease: Power4.easeOut,
                    }
                );
            }
        },
    },
};
</script>

<style lang="scss">
.stat {
    margin-bottom: 0.625em;
    width: 100%;
    color: #333333;

    &.top-border {
        margin-top: 2em;
        border-top: 5px solid #ffffff;
        padding-top: 0.5em;
    }

    .title {
        font-size: 0.85em;
    }

    .bar-container {
        height: 1em;
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .background {
        background-color: #ffffff;
        transform: skewX(-13deg);
        width: 96%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0.25em;
    }

    .values {
        transform: skewX(-13deg);
        background-color: #62bb46;
        transform: skewX(-13deg);
        width: 50%;
        height: 100%;
        margin-left: -0.625em;
        position: absolute;
    }

    .scale {
        position: relative;
        height: 1.5em;

        .scale-item {
            position: absolute;
            transform: translateX(-50%);
            left: 0;
            top: 0;
            font-size: 0.75em;
        }
    }
}
</style>
